// extracted by mini-css-extract-plugin
export var checkbox = "TagCheckboxGroup-module--checkbox--5e5d5";
export var fadeInAnimation = "TagCheckboxGroup-module--fadeInAnimation--b8b17";
export var formSelect = "TagCheckboxGroup-module--formSelect--3038c";
export var formSelectItem = "TagCheckboxGroup-module--formSelectItem--af030";
export var input = "TagCheckboxGroup-module--input--10575";